import React, { useState } from 'react';
import { Section, FadeIn, Button } from './ui';
import { ChevronDown, ShieldCheck } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
const faqs = [{
  q: '¿Necesito comprar suplementos caros?',
  a: 'No. El plan usa tres elementos que ya tienes: luz solar, agua y alimentos reales de tu cocina. Sin pastillas, sin polvos, sin gastos extras.'
}, {
  q: '¿Es muy difícil de seguir?',
  a: 'No. Está diseñado para mujeres ocupadas. Los micro-ajustes toman entre 5 y 15 minutos. No cambias tu vida, solo cambias el orden de lo que ya haces.'
}, {
  q: '¿Tengo que dejar el café?',
  a: 'No lo dejas, lo mueves. El plan te explica el momento exacto para tomarlo sin que dispare tu cortisol ni te robe energía a media mañana.'
}, {
  q: '¿Funciona si ya pasé la menopausia?',
  a: 'Sí, especialmente para ti. Los principios de sincronización hormonal son más importantes en la post-menopausia, cuando el cuerpo más necesita estas señales de ritmo para producir energía estable.'
}, {
  q: '¿Cuánto tiempo toma ver resultados?',
  a: 'La mayoría nota menos pesadez mental al despertar entre el día 5 y 7. La energía sostenida durante el día llega en la semana 2 y 3.'
}, {
  q: '¿Es un plan de dieta?',
  a: 'No. Es un plan de energía. La nutrición es solo una parte. El enfoque real es sincronizar tu ritmo circadiano para que tu cuerpo produzca vitalidad de forma natural.'
}];
const AccordionItem = ({
  q,
  a,
  defaultOpen = false
}: {
  q: string;
  a: string;
  defaultOpen?: boolean;
}) => {
  const [isOpen, setIsOpen] = useState(defaultOpen);
  return <div className="border-b border-cream-dark last:border-0" data-id="element-60">
      <button onClick={() => setIsOpen(!isOpen)} className="w-full py-6 flex items-center justify-between text-left focus:outline-none" data-id="element-61">
        <span className="text-lg font-bold text-brown pr-8" data-id="element-62">{q}</span>
        <motion.div animate={{
        rotate: isOpen ? 180 : 0
      }} transition={{
        duration: 0.2
      }} data-id="element-63">
          <ChevronDown className="w-5 h-5 text-gold" data-id="element-64" />
        </motion.div>
      </button>
      <AnimatePresence data-id="element-65">
        {isOpen && <motion.div initial={{
        height: 0,
        opacity: 0
      }} animate={{
        height: 'auto',
        opacity: 1
      }} exit={{
        height: 0,
        opacity: 0
      }} transition={{
        duration: 0.3,
        ease: 'easeInOut'
      }} className="overflow-hidden" data-id="element-66">
            <p className="pb-6 text-brown-light" data-id="element-67">{a}</p>
          </motion.div>}
      </AnimatePresence>
    </div>;
};
export const FAQSection = () => {
  return <>
      <Section bg="bg-white" data-id="element-68">
        <FadeIn data-id="element-69">
          <div className="max-w-3xl mx-auto" data-id="element-70">
            <h2 className="text-3xl md:text-4xl font-bold mb-12 text-center" data-id="element-71">
              Preguntas Frecuentes
            </h2>
            <div className="bg-cream-light rounded-3xl p-6 md:p-10 shadow-sm" data-id="element-72">
              {faqs.map((faq, i) => <AccordionItem key={i} q={faq.q} a={faq.a} defaultOpen={i === 0} data-id="element-73" />)}
            </div>
          </div>
        </FadeIn>
      </Section>

      <Section bg="bg-cream-dark/30" className="border-t border-cream-dark" id="precio" data-id="element-74">
        <FadeIn data-id="element-75">
          <div className="max-w-4xl mx-auto bg-white rounded-3xl shadow-xl overflow-hidden" data-id="element-76">
            <div className="grid md:grid-cols-2" data-id="element-77">
              <div className="p-10 md:p-12 flex flex-col justify-center" data-id="element-78">
                <h2 className="text-3xl md:text-4xl font-bold mb-6" data-id="element-79">
                  El cambio que tu cuerpo necesita, al alcance de un clic.
                </h2>
                <p className="text-lg text-brown-light mb-8" data-id="element-80">
                  Obtén el Plan de 21 Días de Vitalidad Menopáusica con todas
                  las guías y herramientas de implementación inmediata.
                </p>

                <div className="mb-8" data-id="element-81">
                  <span className="text-sm text-brown-light uppercase tracking-wider font-bold" data-id="element-82">
                    Inversión única
                  </span>
                  <div className="flex items-baseline gap-3 mt-1" data-id="element-83">
                    <span className="text-2xl text-brown-light/50 line-through font-medium" data-id="element-84">
                      $19
                    </span>
                    <span className="text-5xl font-bold text-coral" data-id="element-85">$6.39</span>
                    <span className="text-2xl text-brown-light font-normal" data-id="element-86">
                      USD
                    </span>
                  </div>
                  <span className="inline-block mt-2 bg-sage-light text-sage text-sm font-bold px-3 py-1 rounded-full" data-id="element-87">
                    ¡Ahorra 66%!
                  </span>
                </div>

                <Button fullWidth href="https://edadradiante.com/cart/52950970204271:1" onClick={() => {
                try {
                  const fbq = (window as any).fbq;
                  if (fbq) fbq('track', 'AddToCart');
                } catch (e) {}
              }} data-id="element-88">
                  ¡SÍ, QUIERO RECUPERAR MI ENERGÍA AHORA!
                </Button>

                <div className="mt-6 bg-cream border border-cream-dark rounded-2xl p-6 text-center" data-id="element-89">
                  <ShieldCheck className="w-8 h-8 text-sage mx-auto mb-3" data-id="element-90" />
                  <h4 className="font-bold text-brown mb-2 text-lg" data-id="element-91">
                    Garantía de 7 Días Sin Riesgo
                  </h4>
                  <p className="text-sm text-brown-light leading-relaxed" data-id="element-92">
                    Si en los próximos 7 días sientes que el Plan de 21 Días de
                    Vitalidad no fue para ti, te devolvemos cada centavo. Sin
                    preguntas. Sin burocracia. Tu confianza vale más que tu
                    dinero.
                  </p>
                </div>

                <p className="mt-6 text-sm text-center text-brown-light/80" data-id="element-93">
                  Acceso instantáneo tras la compra. Tu nueva vitalidad comienza
                  mañana mismo.
                </p>
              </div>

              <div className="bg-sage-light/20 p-10 flex items-center justify-center relative overflow-hidden" data-id="element-94">
                <div className="absolute inset-0 bg-gradient-to-br from-sage/10 to-transparent" data-id="element-95"></div>
                <img src="https://cdn.magicpatterns.com/uploads/9G6aWdx1gpXNMEYmywpptz/Plan_21_Dias_de_Vitalidad_Menopausica.png" alt="Plan de 21 Días" className="w-full max-w-sm rounded-xl shadow-2xl relative z-10 transform rotate-2 hover:rotate-0 transition-transform duration-500" data-id="element-96" />
              </div>
            </div>
          </div>
        </FadeIn>
      </Section>
    </>;
};